import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

// used to check password
export const useForgotPassword = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    type CheckEmailPayload = {
        BaseUrl: string;
        Email: string;
    };

    return {
        ...useMutation({
            mutationFn: async (payload: CheckEmailPayload) => {
                return http.post(`${base}${lang}/passwordreset/`, payload);
            },
            onSuccess: async (response, variables, context) => {},
            onError: (error, variables, context) => {
                console.log('error');
            },
        }),
    };
};
